export default {
  'moduleTitle.address': 'Adres',
  'moduleTitle.address_details': 'Adres Detayları',
  'moduleTitle.activity_details': 'Aktivite Detayları',
  'moduleTitle.add_log': 'Ekle',
  'moduleTitle.award_level': 'Ödül Kategorisi',
  'moduleTitle.adventurous_journey': 'Macera ve Keşif Yolculuğu',
  'moduleTitle.already_assessed': 'Zaten Değerlendirildi!',
  'moduleTitle.approved': 'Onaylandı!',
  'moduleTitle.assessor_details': 'Danışman Detayları',
  'moduleTitle.authorising_contact_license_holder': 'Lisans Sahibi',
  'moduleTitle.category_journey_details': '{category} Macera ve Keşif Yolculuğu Detayları',
  'moduleTitle.complete_report': 'Bitmiş Rapor',
  'moduleTitle.completed_progress': 'Tamamlandı {finished} / {total} ',
  'moduleTitle.congratulation': 'Tebrikler!',
  'moduleTitle.confirming_email_address': 'Email adresi onaylanıyor...',
  'moduleTitle.contact_details': 'İletişim Detayları',
  'moduleTitle.edit_log': 'Aktivite Detaylarını Düzenle',
  'moduleTitle.event_journey': '{event} Macera ve Keşif Yolculuğı ',
  'moduleTitle.forgotten_password': 'Şifremi Unuttum',
  'moduleTitle.great_you_are_almost_there': 'Neredeyse bitti. Ödeme için son adımdasınız.',
  'moduleTitle.home_address': 'Ev Adresi',
  'moduleTitle.journey_overview': 'Macera ve Keşif Yolculuğu Genel Bakış ',
  'moduleTitle.log_detail': 'Aktivite Kaydı Detayları',
  'moduleTitle.login': 'Giriş',
  'moduleTitle.new_activity': 'Yeni Aktivite',
  'moduleTitle.new_event_journey': 'Yeni {event} Yolculuğu',
  'moduleTitle.new_residential_project': 'Yeni Toplumsal Uyum Projesi',
  'moduleTitle.notRegistred': 'Kayıt Olmadınız mı?',
  'moduleTitle.nominated_award_leader_contact_details': 'Birincil Ödül Lideri/Koordinatör İletişim Bilgileri ',
  'moduleTitle.nominated_award_leader': 'Birincil Ödül Lideri/Koordinatör',
  'moduleTitle.organisation_address': 'Kurum Adresi',
  'moduleTitle.organisation_details': 'Kurum Bilgisi',
  'moduleTitle.online_record_book_account': 'Online Record Book Hesabı',
  'moduleTitle.page_not_found': '404-Sayfa Bulunamıyor',
  'moduleTitle.personal_details': 'Kişisel Bilgiler',
  'moduleTitle.preparation_and_training': 'Hazırlık ve Eğitim',
  'moduleTitle.profile_guardian_consent': 'Ebeveyn Onayı ',
  'moduleTitle.profile_questions': 'Profil Soruları ',
  'moduleTitle.registration_for_level': 'Bir sonraki kategori için kayıt',
  'moduleTitle.residential_project': 'Toplumsal Uyum Projesi',
  'moduleTitle.residential_project_details': 'Toplumsal Uyum Projesi Detayları',
  'moduleTitle.reset_password': 'Şifre Yenileme',
  'moduleTitle.welcome_to_the_orb': "Online Record Book'a Hoş Geldiniz",
  'moduleTitle.we_have_sent_you_an_email': 'Aktivasyon linki size email olarak gönderilmiştir.',
  'moduleTitle.your_registration_is_complete': 'Kaydınız tamamlanmıştır',
  'formTitle.activity_details': 'Aktivite Detayları ',
  'formTitle.assessor_details': 'Aktivite Detayları',
  'formTitle.supervisors_details': 'Supervisor Detayları',
  'formTitle.preparation_and_training_activities': 'Hazırlık ve Eğitim Etkinlikleri',
  'formTitle.added_preparation_activities': 'Hazırlık ve Eğitim Etkinlikleri Ekle',
  'label.add_picture': 'Resim Ekle',
  'label.address_first_line': 'Adres (ilk satır)',
  'label.address_second_line': 'Adres (ikinci satır)',
  'label.are_you_already_running_award': 'Ödüle devam ediyor musunuz?',
  'label.are_you_the_main_award_leader': 'Ödül Biriminizdeki Ana Ödül Koordinatörü ya da Lideri siz misiniz?',
  'label.award_participant': 'Ödül Katılımcısı',
  'label.award_leader': 'Ödül Lideri',
  'label.birthdate': 'Doğum Tarihi',
  'label.category': 'Kategori',
  'label.change_locale': 'Yer Değiştir',
  'label.choose_project': 'Proje Seç',
  'label.city': 'Şehir ',
  'label.choose_as_major_activity': 'Uzun Süreli Aktivite Olarak Seç ',
  'label.date': 'Tarih ',
  'label.date_of_birth': 'Doğum Tarihi',
  'label.description_of_progress': 'İlerlemeniz ile ilgili açıklama ',
  'label.duration': 'Süre (dk)',
  'label.email': 'Email',
  'label.email_address': 'Email Adresi',
  'label.email_again': 'Email Tekrar',
  'label.employment_status': 'Çalışma Şekli ',
  'label.end_date': 'Bitiş Tarihi',
  'label.enter_his_email': 'Email Adresinizi Giriniz',
  'label.entered_transaction_id': "Ödeme ID'si",
  'label.first_name': 'İlk İsim',
  'label.gender': 'Cinsiyet',
  'label.goal': 'Hedef',
  'label.journey_activity': 'Macera ve Keşif Yolculuğu Etkinliği',
  'label.journey_objective': 'Yolculuk Hedefi',
  'label.journey_observations': 'Yolculuk Gözlemleri ',
  'label.journey_type': 'Yolculuk Türü',
  'label.last_name': 'Soyisim',
  'label.level': 'Kategori',
  'label.location': 'Yer',
  'label.logout': 'Çıkış',
  'label.major': 'Uzun Süreli Akitvite',
  'label.middle_name': 'İkinci İsim',
  'label.mode_of_transport': 'Ulaşım Şekli ',
  'label.my_award_leader': 'Ödül Liderim',
  'label.name': 'İsim',
  'label.nationality': 'Uyruk',
  'label.no': 'Hayır',
  'label.no_results': 'Sonuç Yok ',
  'label.note': 'Not',
  'label.note_for_assessor': 'Danışman için Not',
  'label.note_for_leader': 'Ödül Lideri için Not',
  'label.optional': 'opsiyonel',
  'label.organisation_name': 'Kurum İsmi',
  'label.organisation_type': 'Kurum Türü',
  'label.others': 'Diğer',
  'label.password': 'Şifre',
  'label.password_again': 'Şifreyi Tekrarlayın',
  'label.project_location': 'Proje Yeri',
  'label.pay_online': 'Online Ödeme',
  'label.pay_award_leader_or_unit': 'Ödül Liderine veya Ödül Birimine Ödeme',
  'label.payment_not_required': 'Ödeme Gerekmemektedir',
  'label.payment_type': 'Ödeme Türü:',
  'label.phone': 'Telefon',
  'label.phone_number': 'Telefon Numarası',
  'label.phone_type': 'Telefon Türü',
  'label.profile': 'Profil',
  'label.reset_password': 'Şifre Yenileme',
  'label.region': 'İlçe',
  'label.relationship': 'İlişki ',
  'label.role_in_organisation': 'Kurumdaki Görevi',
  'label.select_country': 'Ülke Seçiniz',
  'label.select_your_au': 'Ödül Biriminizi Seçiniz',
  'label.start_typing': 'Yazmaya başlayınız',
  'label.start_date': 'Başlangıç Tarihi',
  'label.select': 'Seç',
  'label.select_async': 'Yazmaya başlayınız...',
  'label.select_your_operating_authority': 'Operatör Otoritenizi Seçiniz ',
  'label.specify_category': 'Kategorinizi Belirleyiniz',
  'label.subcategory': 'Alt Kategori ',
  'label.title': 'Başlık',
  'label.username': 'Kullanıcı Adı',
  'label.what_is_your_role': 'Kurumdaki göreviniz nedir?',
  'label.where_have_you_completed': 'Nerede tamamladınız?',
  'label.yes': 'Evet',
  'label.your_changes_havent_been_saved': 'Değişiklikleriniz kaydedilmemiştir. Verileriniz kaybolacaktır. ',
  'label.zip': 'Zip/Posta Kodu',
  'label.adventurous_journey': 'Macera ve Keşif Yolculuğu ',
  'label.after_your_journey_describe': 'Macera ve Keşif Yolculuğu ile ilgili görüşlerinizi bir kaç cümle ile anlatınız. ',
  'label.because_your_age_is_under_18': '18 yaşının altnda olduğunuz için, ebeveyninizin onayı gerekmektedir. ',
  'label.before_you_head_to_journey': 'Asıl Yolculuğa başlamadan önce, Hazırlık ve Eğitim aşamasını tamamlamanız gerekmektedir. ',
  'label.before_entering_new_level': 'Yeni Kategoriye başlamadan önce lüten, kişisel bilgilerinizin güncel olduğunu onaylayıız. ',
  'label.bring_required_amount_to_your_award_leader': 'Gerekli tutarı Ödül Biriminizdeki Ödül Liderinize ya da Ödül Koordinatörünüze götürün. ',
  'label.do_you_have_any_other_level': 'Önceki Ödül Kategorilerini tamamladınız mı?',
  'label.do_you_know_who_is_your_award_leader': 'Ödül Liderinizi tanıyor musunuz?',
  'label.going_on_an_expedition': 'Bir kampa gitmek size macera yaşama, ekip olarak çalışma ve insiyatif alma şansı verir. ',
  'label.going_on_residential_gives_chance': 'Toplumsal Uyum Projesine gitmek size farklı insanlarla bir araya gelme ve yeni ortamlarda özgüveninizi geliştirme şansı verecektir. ',
  'label.i_confirm_that_i_meet': 'Ulusal Ödül Operatörü Yönetmeliğinin her maddesine uyduğumu onaylıyorum. ',
  'label.i_agree_to_volunteer_code': 'Gönüllü Davranış Kurallarını kabul ediyorum. Daha fazla bilgi için burayı tıklayınız.',
  'label.i_have_read_the_terms_and_conditions': 'Şartlar ve Koşulları okudum ve onaylıyorum. ',
  'label.i_will_bring_the_consent_to_my_award_leader_later': 'Onayımı, Ödül Liderime daha sonra götüreceğim. ',
  'label.if_you_are_from_orphanage': 'Yetiştirme yurdundan ödüle katılan kişilerin, ödeme yapmaları gerekmez. ',
  'label.here_you_can_add_activity': 'Buraya daha fazla Hazırlık ve Eğitim Aktivitesi ekleyebilirsiniz. ',
  'label.how_do_you_want_to_apply': 'Nasıl başvurmak istiyorsunuz?',
  'label.my_parent_consent_has_been_already_given': 'Ebeveyn onayım Ödül Liderime verildi.',
  'label.my_parent_will_confirm_consent_by_email': 'Ebeveynim onayını email ile verecek',
  'label.major_activity_means_that_you_have_to_spent': 'Uzun Süreli Aktivite için, diğer aktivitelerin iki katı zaman harcamalısınız. ',
  'label.not_sure_about_your_auth': 'Ödül Otoriteniz ile ilgili emin değil misiniz? Bizimle iletişime geçiniz',
  'label.page_not_found': '404-Sayfa Bulunamıyor',
  'label.please_fill_in_the_following': 'Lütfen kurumunuzdaki yetkili kişinin/lisans sahibi kişinin bilgilerini giriniz ',
  'label.register_a_new_account_as': 'Yeni hesap türü: ',
  'label.residential_project': 'Toplumsal Uyum Projesi',
  'label.select_your_award_unit': 'Ödül Biriminizi seçiniz',
  'label.the_expedition_can_be_faraway': 'Kampınız evinzden çok uzak olabileceği gibi yakın bir yerde de yapılabilir.',
  'label.to_log_your_process_on_orb': "İlerlemenizi Online Record Book'ta (ORB) kaydetmek için, kişisel bir ORB hesabına ihtyacınız var. <br /> Lütfen bilgilerinizi buraya giriniz. ",
  'label.waiting_for_assessment': 'Bekleyen Değerlendirme ',
  'label.waiting_for_sign_off': 'Bekleyen Ödül Lideri Bitirme Onayı.',
  'label.we_have_sent_you_an_email': 'Aktivasyon linki size email olarak gönderilmiştir. ',
  'label.what_level_of_the_award': 'Hangi Kategori için kayıt oluyorsunuz?',
  'label.you_are_now_registering_as_participant': 'Şuan Ödül Katılımcısı olarak kayıt oluyorsunuz. ',
  'label.you_are_now_registering_as_award_unit': 'Şuan Ödül Birimi olarak kayıt oluyorsunuz. ',
  'label.you_can_use_my_photos_for_promotional_purposes': 'Ödül Katılımcısı olarak, resimlerimin tanıtım amaçlı olarak Uluslararası Ödül Vakfı tarafından kullanılmasına izin veriyorum. ',
  'label.you_can_send_activity_for_approval': 'Aktivitenizi Danışmanınızın onayına gönderebilirsiniz',
  'label.you_can_send_activity_for_leader': 'Aktivitenizi Ödül Liderinizin onayına gönderebilirsiniz.',
  'label.you_can_send_residential_project_to_leader': 'Toplumsal Uyum Projesinizi Ödül Liderinizin onayına gönderebilirsiniz. ',
  'label.you_have_finished_now_send_to_approval': 'Bu bölümü tamamladınız. Danışmanınızın onayına kendi notunuzu yazarak gönderebilirsiniz. ',
  'label.preparation_and_training': 'Hazırlık ve Eğitim',
  'label.you_will_be_redirected_to_the_payment': 'Ödeme bölümüne yönlendirileceksiniz, burada kredi kartınızı ya da hesap kartınız ile ödeme yapabilirsiniz. ',
  'label.you_will_be_the_first_award_leader': 'Kurumunuzdaki ilk Ödül Lideri sizsiniz. ORB sisteminde, daha fazla Ödül Lideri ve Katılımcı eklemeye, Ödül sürecini yönetmeye yetkiniz vard',
  'label.youll_receive_a_notification': "Ödül Lideriniz kaydınızı onayladığında bir bildirim alacaksınız. Buradan ORB Next Generation'a giriş yapabilirsiniz<a>here</a> (Ödül Lideriniz kaydınızı onaylayana kadar sistemde sınırlı işlem yapabileceksiniz). ",
  'label.your_parent_email': 'Ebeveyninizin Email Adresi',
  'label.your_parent_first_name': 'Ebeveyninizin İlk İsmi',
  'label.your_parent_last_name': 'Ebeveyninizin Soyismi',
  'label.your_report_approve_now_send_to_leader': 'Raporunuz Danışmanınız tarafından onaylandı. Şimdi raporunuzu Ödül Liderinizin onayına kendi notunuz ile gönderebilirsiniz. ',
  'label.there_are_loads_of_exciting_possibilities': 'Çok sayıda güzel fırsat var. Sizi tatmin eden bir seçenek seçiniz. ',
  'label.your_residential_project_has_been_setup': 'Toplumsal Uyum Projeniz planlandı ve Ödül Liderinizin onayına gönderildi. ',
  'label.your_report_has_been_sent_assessor': 'Raporunuz Danışmanınızın onayına gönderilmiştir.',
  'label.your_report_has_been_sent_leader': 'Raporunuz Ödül Liderinizin onayına gönderilmiştir. ',
  'label.your_residential_project_is_complete': 'Toplumsal Uyum Projeniz tamamlandı.',
  'label.to_work_on_the_online': 'Online Record Book (ORB) ile çalışmak için, kişisel ORB hesabınızı açmanız gerekmektedir. ',
  'label.we_will_send_you_an_email': 'ORB hesabınız onaylandığında sizi email yollayacağız. ',
  'label.if_you_have_any_problems_or_doubts': 'Problemleriniz ve sorularınız için Ödül Biriminiz ile iletişime geçebilirsiniz. ',
  'label.are_you_sure_you_want_to_leave': 'Ayrılmak istediğinizden emin misiniz? Verileriniz kaybolacak. ',
  'label.no_logs_yet': "Henüz bir aktivite kaydı bulunmuyor. <br /> ''Kaydet'' butonuna basarak yeni aktivite kaydı ekleyebilirsiniz. ",
  'label.menu': 'Menü',
  'notifications.award_unit_has_been_created': 'Ödül Birimi oluşturuldu',
  'notifications.authorization_code_is_not_valid': 'Yetkilendirme kodu geçerli değil ',
  'notifications.email_has_been_confirmed': 'Email adresi onaylanmıştır',
  'notifications.leader_has_been_created': 'Lider oluşturuldu ',
  'notifications.participant_has_been_created': 'Katılımcı oluşturulmuştur',
  'notifications.email_with_instructions_has_been_sent': 'Açıklama emaili size gönderilmiştir',
  'notifications.your_new_password_has_been_set': 'Yeni şifreniz size gönderilmiştir',
  'notifications.success': 'Başarı ',
  'notifications.unknown_role': 'Bilinmeyen Görev ',
  'notifications.waiting_for_approval': 'Bekleyen Onay',
  'notifications.activity_cannot_be_created': 'Aktiviteniz, başvurunuz onaylanana kadar oluşturulamaz.',
  'notifications.new_activity_has_been_added': 'Yeni aktivite eklenmiştir',
  'notifications.new_log_has_been_added': 'Yeni aktivite kaydı eklenmiştir',
  'notifications.log_has_been_deleted': 'Yeni aktivite kaydı silinmiştir',
  'notifications.log_has_been_modified': 'Yeni aktivite kaydı düzenlenmiştir',
  'notifications.adventurous_journey_cannot_be_created_until_approved': 'Macera ve Keşif Yolculuğu kaydınız onaylanmadığı için oluşturulamamıştır',
  'notifications.new_participant_event_has_been_added': 'Yeni katılımcı etkinliği eklendi ',
  'notifications.participant_event_has_been_completed': 'Katılımcı etkinliği tamamlandı',
  'notifications.training_and_practice_modified': 'Hazırlık ve Eğitim düzenlendi ',
  'notifications.completion_residential_project_completed': 'Toplumsal Uyum Projesi tamamlandı ',
  'notifications.new_residential_project_has_been_added': 'Yeni Toplumsal Uyum Projesi eklendi',
  'notifications.residential_project_cannot_be_created_until_approved': 'Toplumsal Uyum Projenizi, başvurunuz onaylanana kadar oluşturulamaz.',
  'notifications.already_assessed_sent': 'Ödül Lideri onayı gönderildi',
  'notifications.assessment_request_sent': 'Değerlendirme isteği gönderildi ',
  'notifications.leader_approval_sent': '\nÖdül Lideri onayı gönderildi',
  'tabs.logs': 'Aktivite Kayıtları',
  'tabs.new': 'Yeni',
  'tabs.overview': 'Genel Bakış ',
  'tabs.report': 'Rapor',
  'button.add_activity': 'Aktivite Ekle ',
  'button.add_log': 'Ekle ',
  'button.continue_here': 'Buradan devam et ',
  'button.continue': 'Devam et ',
  'button.continue_to_award': 'Ödüle devam et ',
  'button.delete': 'Sil',
  'button.edit': 'Düzenle',
  'button.edit_log': 'Aktivite Kaydını Düzenle ',
  'button.finish': 'Bitir',
  'button.forgot_your_password': 'Şifrenizi mi unuttunuz?',
  'button.i_already_have_assessment': 'Gerekli değerlendirme daha önce yapıldı',
  'button.leave_anyway': 'Yinede ayrıl ',
  'button.login': 'Giriş',
  'button.no': 'Hayır',
  'button.register': 'Kayıt Ol ',
  'button.send': 'Yolla',
  'button.send_for_approval': 'Onaya Gönder',
  'button.setup': 'Planla',
  'button.setup_residential': 'Toplumsal Uyum Projesi Planla ',
  'button.stay': 'Kal ',
  'button.submit': 'Gönder ',
  'button.update': 'Güncelle',
  'button.yes': 'Evet',
  'errors.at_least_num_characters': 'En az  {length} karakter ',
  'errors.do_not_match': 'Eşleşmiyor ',
  'errors.include_at_least_one_number': 'En az bir rakam içermelidir',
  'errors.include_both_lower_and_upper_case': 'Büyük ve küçük harf içermelidir',
  'errors.invalid_phone_format': 'Geçersiz telefon numarası formatı',
  'errors.invalid_email_address': 'Gerçersiz email adresi',
  'errors.required_field': 'Gerekli alan',
  'errors.must_be_at_least': 'Ez az {min} karakter',
  'errors.must_be_no_more_than': '{max} karakterden daha fazla olmalı',
  'errors.must_be_an_integer': 'Tamsayı olmalıdır',
  'errors.must_contain_at_least': 'En az bir rakam içermelidir',
  'errors.must_include_at_least': 'Büyük ve küçük harf içermelidir',
  'errors.must_be_one_of': 'Bunlardan biri olmalıdır: {enums}',
  'errors.you_must_be_younger_than': 'Ödüle kayıt olabilmek için  {years} yaşından daha küçük olmanız gerekmektedir. Lütfen Ödül Biriminzdeki yetkili bir kişi ile konuşun. ',
  'errors.you_must_be_older_than': 'Ödüle kayıt olabilmek için {years} yaşından büyük olmanız gerekmektedir. Lütfen Ödül Biriminizdeki yetkişi bir kişi ile konuşun.',
  'errors.email_address_is_in_use_please_sign': 'Bu email adresi kullanılıyor, yeni Ödül Kategorisine başvurmak istiyorsanız, kendi hesabınız ile giriş yapabilirsiniz. ',
  'errors.email_address_is_in_use': 'Bu email adresi zaten kullanılıyor',
  'errors.sorry_we_already_have_this_email': "Üzgünüz, bu email adresi ile açılmış bir hesap mevcuttur. Yeni Ödül Kategorisine naşlamak için <a href='/'>log to your account</a> ve Başla'yı seçerek yeni Kategori ile başlayın.  ",
  'wizard.authorising_contact': 'Yetkili Kişi',
  'wizard.award_leader_contact': 'Ödül Lideri İletişim ',
  'wizard.award_unit_details': 'Ödül Birimi Bilgileri ',
  'wizard.contact_details': 'İletişim Bilgileri ',
  'wizard.contacts': 'İletişim Bilgileri',
  'wizard.level': 'Ödül Kategorisi',
  'wizard.level_selection': 'Ödül Seçimi ',
  'wizard.leader_details': 'Ödül Lideri Detayları',
  'wizard.nominated_award_leader': 'Birincil Ödül Lideri/Koordinatör',
  'wizard.orb_account': 'ORB Hesabı',
  'wizard.parent_consent': 'Ebeveyn Onayı',
  'wizard.participant_details': 'Katılımcı Detayları',
  'wizard.profile': 'Profil',
  'wizard.payment': 'Ödeme',
  'wizard.select_award_unit': 'Ödül Birimi Seçiniz',
  'wizard.unit_details': 'Ödül Birimi Bilgileri ',
  'wizard.welcome': 'Hoş Geldiniz',
  'wizard.your_details': 'Bilgileriniz',
  'awardUnit.do_you_want_to_create': 'Yeni Ödül Birimi oluşturmak istiyor musunuz?',
  'parent.you_can_download_the_consent_here': 'Ebeveyn Onay formunuz yoksa, buradan indirebilirsiniz. Ebeveyninize bu formu imzalatarak Ödül Liderinize teslim ediniz. ',
  'footer.copyright': "&copy; Copyright The Duke of Edinburgh's International Award {year}",
  'registration_participant.required_award_payment': 'Zorunlu Ödeme',
  'registration_participant.pay_online_here': "Online ödebilir ve buradan ödeme ID'nizi alabilirsiniz.",
  'dashboard.activity_log_time': '{hours}saat{minutes}dk.',
  'moduleTitle.award_completed': 'Ödül Tamamlandı!',
  'notifications.award_approval_request_sent_to_leader': 'Ödül onayınız Ödül Liderinzin onayına göderilmiştir.',
  'notifications.new_participant_event_has_been_completed': 'Yeni katılımcı etkiniliği tamamlandı',
  'notifications.preparation_and_training_approval_sent': 'Hazırlık ve eğtim onayı gönderilmiştir',
  'notifications.reparation_and_training_completed': 'Hazırlık ve Eğitim tamamlandı',
  'notifications.your_profile_photo_has_been_edited': 'Profil resminiz düzenlenmiştir',
  'notifications.your_profile_has_been_edited': 'Profiliniz düzenlenmiştir',
  'notifications.new_level_has_started': 'Yeni Kategoriye Başlanmıştır',
  'notifications.activity_has_been_edited': 'Aktivie düzenlenmiştir',
  'notifications.you_have_been_logged_out': 'Çıkış yapılıyor...',
  'notifications.logging_out': 'Çıkış yaptınız',
  'label.you_can_send_award_to_leader': 'Ödülünüzü Ödül Liderinizin onayına gönderebilirsiniz',
  'label.you_have_completed_all_sections_of_your_award': 'Ödülün tüm bölümlerini tamamladınız. Ödülünüzü, Ödül Liderinizin onayına kendi kişisel notunuzu ekleyerek gönderebilirsiniz. ',
  'label.you_have_now_completed_your_award': '{level} Kategori Ödülünüzü tamamladınız. Yeni kategoriye başlamak ister misiniz?',
  'label.congratulation_your_award_has_been_approved': 'Tebrikler. {level} Kategori Ödülünüz onaylandı! <br /> İsterseniz yeni Ödül Kategorisi ile devam edebilirsiniz. ',
  'moduleTitle.settings': 'Ayarlar',
  'moduleTitle.edit_activity': 'Aktiviteyi Düzenle ',
  'moduleTitle.select_your_major_activity': 'Uzun Süreli Aktivitenizi Seçiniz',
  'label.settings': 'Ayarlar',
  'label.major_activity_means_that_you_will': 'Uzun süreli aktivitenizi, diğer aktivitelere oran daha uzun süre yapmalısınız. Altın ve Gümüş Kategori için bu aktivitteyi diğer aktiviteye oranla süre 6 ay, Bronze kategorisinde ise bu süre 3 aydır.',
  'label.notifications': 'Bildirimler',
  'label.my_award': 'Ödülüm',
  'label.physical_recreation': 'Fiziksel Gelişim',
  'label.skill': 'Beceri',
  'label.service': 'Toplumsal Hizmet',
  'label.my_parent_will_complete_and_sign_form': 'Ebeveynimi, ebeveyn onay formunu dolduracak ve imzalayacak',
  'label.please_print_it_tak_it_to_your_parent': 'Çıktısını alarak ebeveyninize imzalatın ve daha sonra Ödül Liderinize teslim edin ',
  'label.change_password': 'Şifremi Değiştir',
  'label.change_major_activity': 'Uzun Süreli Aktiveteyi Değişitir',
  'title.change_password': 'Şifremi Değiştir',
  'label.old_again': 'Eski Şifre',
  'label.new_password': 'Yeni Şifre',
  'label.new_password_again': 'Yeni Şifre Tekrar',
  'errors.passwords_dont_match': 'Şifreler uyuşmuyor',
  'errors.more_than': '{limit}dan fazla',
  'button.parent_guardian_consent_pdf': 'Ebeveyn Onayı,pdf',
  'button.send_award_for_approval': 'Ödülü onaya gönder',
  'button.send_report': 'Rapor Yolla',
  'button.terms_and_conditions': 'Uluslararası Hükümler& Koşullar',
  'button.privacy_policy': 'Gizlilik Politikası',
  'button.save': 'Kaydet',
  'button.start_new_level': 'Yeni Kategoriye Başla',
  'button.change_password': 'Şifremi Değiştir',
  'button.edit_activity': 'Aktiviteyi Düzenle',
  'moduleTitle.file_upload': 'Dosya Yükleme',
  'label.add_file': 'Dosya Ekleme',
  'label.description': 'Açıklama',
  'label.waiting_for_office_sign_off': 'Beklenen, Ulusal Ofis Ödül Bitirme Onayı',
  'notifications.file_has_been_uploaded': 'Dosya yüklendi',
  'tabs.files': 'Dosyalar',
  'button.upload': 'Yükle',
  'button.upload_file': 'Dosya Yükle',
  'button.add_file': 'Dosya Ekle',
  'button.this_activity_has_no_assessor': 'Bu aktivite için bir danışman bulunmamaktadır. Aktivitenizi onaya göndermeden önce, gerekli danışman bilgilerini girmelisiniz.',
  'label.i_want_to_register_my_award': 'Ödül Birimim için Bağımsız Ödül Merkezi olarak kayıt yapmak istiyorum',
  'label.select_sub_operating_authority': 'Operatör Otorite Seç',
  'label.your_must_first_setup_some_activity': 'Önce aktivite oluşturmalısınız',
  'label.you_cant_change_your_major_activity': 'Uzun süreli aktivitenizi tamamladığınız için uun süreli aktivitenizi değiştiremezsiniz.',
  'label.s_specific': "Specific/Spesifik: Hedefiniz çok geniş olmamalıdır. Örneğin: '' İyi keman çalmayı öğrenmek istiyorum'' yerine '' Keman çalarken Fahreneit skalasında çok iyi olmak istiyorum'' yazabilirsiniz.",
  'label.m_measurable': "Measurable/Ölçülebilir: Hedefiniz için hangi günler çalışacağınızı belirtmelisiniz. Örneğin: ''İnsanlara yardım etmek'' yerine '' Haftada bir gönüllü olarak aş evindeki insanlara yardım etmek''.\n",
  'label.a_achievable': "Achievable/Ulaşılabilir: Hedefiniz, Ödül Kategorinizde belirlenen zaman aralığı içinde tamamlanabilir olmalı. '' Fakirliğe çözüm bulmak'' yerine daha yapılabilir hedefler yazmalısınız. Örneğin: '' Fon ve bağış toplayarak bunu ihtiyacı olan insanlara dağıtmak''.",
  'label.r_realistic': "Realistic/Gerçekçi: Hedefiniz belirtilen zamanda ve kapsamda bitirilebilir misiniz? Örneğin '' Karakalem ile portre çizmeyi 1 hafta içinde öğrenmek'' ya da '' 3 ayın sonunda Everest'e tırmanabilmek'' gerçekçi bir hedef olmayacaktır.",
  'label.t_timely': "\nTimely/ Planlı: Hedefinize ne zaman ulaşacağınızı belirtmelisiniz. ''Örneğin 3 ay içinde karakalem resim çizebilmek'', sizin hedefiniz olabilir.\n",
  'label.you_can_upload_here_any_files': 'Buraya Ödül Liderinizle paylaşmak istediğiniz tüm dokümanları yükleyebilirsiniz.',
  'moduleTitle.login_change': 'Giriş Bilgilerini Değiştir',
  'notifications.adventurous_journey_modified': 'Macera ve Keşif Yolculuğu',
  'tabs.sections': 'Bölümler',
  'label.change_email': 'Email değiştir',
  'title.change_email': 'Email değiştir',
  'label.new_email': 'Yeni Email',
  'label.new_email_again': 'Yeni email tekrar',
  'errors.emails_dont_match': 'Email adresleri uyuşmuyor',
  'button.change_email': 'Email adresini değiştir',
  'notifications.email_with_instructions_has_been_sent_to_your_inbox': 'Yönlendirmeleri içeren email size gönderilmiştir',
  'global.dofe_name': 'Edinburg Dükü Uluslararası Gençlik Ödülü',
  'global.or': 'ya da',
  'route.landing_page': 'Açılış Sayfası',
  'route.dashboard': 'Pano',
  'moduleTitle.notifications': 'Bildirimler',
  'moduleTitle.no_notifications': 'Henüz bildirim bulunmuyor',
  'moduleTitle.new_notifications': 'Yeni Bildirimler',
  'moduleTitle.older_notifications': 'Geçmiş Bildirimler',
  'moduleTitle.user_guide': 'Kullanıcı Kılavuzu',
  'label.user_guide': 'Kullanıcı Kılavuzu',
  'notifications.your_password_has_been_changed': 'Şifreniz değiştirildi',
  'label.country': 'Ülke',
  'label.on_your_smartphone': 'Telefonunuzda',
  'label.on_the_web': 'İnternette',
  'label.orb_online': 'ORB Online',
  'label.language': 'Dil',
  'moduleTitle.participant_login': 'Katılımcı Girişi',
  'label.for_ios': 'İOS için',
  'label.for_android': 'Android için',
  'button.login_as_award_staff': 'Ödül Çalışanı Girişi',
  'errors.leader_doesnt_exist': 'Ödül Lideri bulunmuyor',
  'global.loading': 'Yükleniyor',
  'moduleTitle.award_staff_login': 'Ödül Lideri/Koordinatörü olarak giriş yap',
  'formTitle.residential_project_details': 'Toplumsal Uyum Projesi Detayları',
  'label.you_can_also_download_participant': "Yeni Katılımcı Uygulaması<strong> ile Online Record Book'a her yerden, her zaman ulaşabilirisiniz.",
  'label.you_can_also_download_leader': "Yeni Ödül Lideri Uygulaması<strong> ile Online Record Book'a her yerden, her zaman ulaşabilirisiniz.",
  'notifications.this_role_is_not': 'Bu görev şuan için desteklenememektedir',
  'notifications.residential_project_has_been_updated': 'Toplumsal Uyum Projesi güncellendi',
  'tabs.participant': 'Katılımcı',
  'tabs.award_staff': 'Ödül Lideri/Koordinatörü',
  'moduleTitle.edit_residential_project': 'Toplumsal Uyum Porojesini Düzenle',
  'button.residential_project': 'Toplumsal Uyum Porojesini Düzenle',
  'notifications.your_login_email_has_been_changed': 'Kayıtlı email adresiniz değiştirildi',
  'meta.dofe_name': 'Edinburg Uluslararası Gençlik Ödülü Programı',
  'notifications.unknown_role_leader': 'Bilinmeyen Görev - Ödül Lideri/Koordinatörü girişini kullanınız',
  'notifications.unknown_role_participant': 'Bilinmeyen Görev - Katılımcı girişini kullanınız',
  'label.user_guide_web_participant': 'Katılımcı- Web Kullanıcı Kılavuzu',
  'label.user_guide_app_participant': 'Katılımcı - Uygulama Kullanıcı Kılavuzu',
  'label.note_for_supervisor': 'Supervisor için not',
  'label.before_submitting_your_aj': 'Macera ve Keşif Yolculuğunuzu, Ödül Liderinize göndermeden önce {role} onayıı alınız. İsterseniz onaya gönderirken, kişisel notunuzu ekleyebilirsiniz.',
  'button.back_to_home': 'Ana Sayfaya Dön',
  'moduleTitle.assessor_approval': '{role} Onayı',
  'label.this_aj_has_no_assessor': 'Bu Macera ve Keşif Yolculuğuna atanmış bir {role} yok. Onaya göndermeden önce gerekli bilgileri giriniz.',
  'route.not_found': 'Bulunamadı',
  'notifications.are_you_sure': 'Emin misiniz?',
  'button.cancel': 'İptal',
  'label.add_document': 'Belge Ekle',
  'errors.there_are_currently_no_details_for_your': '{role} için hiç bir veri bulunmamaktadır. Aktivitenizi değerlendirmeyi göndermeden önce lütfen gerekli verileri giriniz',
  'moduleTitle.missing_data': 'Veri eksik',
  'label.to_send_assessment_request': 'Online olarak bir değerlendirme istiyorsanız, lütfen {role} için bir e-posta adresi giriniz.',
  'label.pending_changes': 'Değişiklikler yapılıyor',
  'label.some_fields_require': 'Bazı bölümleri gözden geçirmelisiniz',
  'roles.assessor': 'Danışman/Assessor',
  'roles.supervisor': 'Supervisor',
  'pageTitle.register_participant': 'Katılımcı kaydı',
  'moduleTitle.revise_message': 'Gözden Geçirme Mesajı',
  'moduleTitle.payment_for_level': '{awardLevel} için ödeme',
  'moduleTitle.payment': 'Katılımcı kaydı bağış ödemesi',
  'moduleTitle.we_have_sent_you_payment_link': 'E-posta adresinize sizi Ödeme Sayfasına yönlendirecek link göderilmiştir.',
  'label.required_award_payment': 'Ödenmesi gereken bağış tutarı',
  'label.payment_fees': 'Bağış tutarları',
  'label.payment_method': 'Ödeme yöntemi',
  'label.you_will_type_trans_id': "Sizden ödeme işlemi ID'nizi girmeniz istenecektir.",
  'label.any_level_previously': 'Daha önce tamamlanan kategoriler',
  'label.registering_for_level': 'Kategori için başvuru',
  'notification.payment_link_expired': 'Ödeme linkinin süresi dolmuştur',
  'button.pay': 'Ödeme',
  'label.registration_updated': 'Bu kayıt güncellendi.',
  'label.award_leader_receive_payment': 'Ödül Lideri, ödeme ile ilgili bilgi alacaktır.',
  'errors.end_date_after': 'Bitiş tarihi, başlangıç tarihinden sonra olmalı ',
  'button.back': 'Geri',
  'button.edit_info': 'Bilgileri düzenle',
  'moduleTitle.level_detail': 'Kategori Detayları',
  'label.payment_methods': 'Ödeme yöntemleri',
  'label.address': 'Adres',
  'note.review_filled_participant': 'Katılımcı tarafından girilen bilgiler gözden geçirildi. Bu bilgiler içinden yanlış olanlar varsa, bu bilgileri düzenleyebilirsiniz.',
  'moduleTitle.payment_successful': 'Katılımcı kayıt ödemesi başarıyla tamamlandı.',
  'button.proceed_to_login': 'Giriş yapmak için devam ediniz',
  'label.add_additional_activity': 'İlave aktivite ekle',
  'moduleTitle.welcome_to_orb': "Online Record Book'a Hoş Geldiniz",
  'empty_dashboard.not_approved': 'Bu platform, Ödül Programı süresince kayıtlarınızı tutmanızı ve ilerleminizi görmenizi sağlayacaktır. Fakat, profiliniz Ödül Lideriniz tarafından henüz onaylanmamıştır. İlk aktivitenizi oluşturmadan önce, Ödül Liderinizin onayını beklemelisiniz.',
  'empty_dashboard.approved_1': 'Bu platform, Ödül Programı süresince kayıtlarınızı tutmanızı ve ilerleminizi görmenizi sağlayacaktır.',
  'empty_dashboard.approved_2': 'İlk başta kendinize aktivite belirlemelisiniz. Başlamak için solda bulunan bölümlerden birine tıklayınız. Aktivite oluşturmak için yardıma ihtiyacınız varsa lütfen Ödül Liderinizden destek alınız.',
  'label.discuss_activity_leader': 'Birden fazla aktivite seçiyorsanız lütfen bu konuyu Ödül Lideriniz ile konuşunuz.',
  'label.cannot_add_activity': 'Bu kategori için maksimum 3 aktivite ekleyebilirsiniz. Lütfen bu konuyu Ödül Liderinizle konuşunuz.',
  'button.ok': 'OK',
  'label.payment_was_canceled': 'Ödeme kullanıcı tarafından iptal edildi.',
  'label.problem_with_payment': 'Ödeme sürecinizde bir problem oluştu. Lütfen bu konuyu Ulusal Ödül Opertörü ile konuşunuz.',
  'pageTitle.register_leader': 'Ödül Lideri Kaydı',
  'pageTitle.registration_complete': 'Kayıt Tamamlandı',
  'label.payment_link_expired_or_paid': 'Gerekli kayıt tutarını yatırdınız ya da ödeme linkinizin süresi doldu.',
  'label.contact_nao_assistance': 'Yardım almak için Ulusal Ofis ile iletişime geçiniz.',
  'label.send_required_amount_to_your_award_leader': 'Gerekli miktarı, Ödül Biriminizdeki Ödül Liderinize ya da Ödül Koordinatörünüze yollayınız.',
  'label.fee_can_be_paid': 'Bağış ödemeleri sadece VISA, Master veya Bankomat kartları ile yapılabilir.',
  'notifications.login_failed_right_tab': 'Giriş başarısız',
  'label.i_have_read_privacy_policy': 'Gizlilik Politikasını okudum ve onaylıyorum.',
  'errors.invalid_date_format': 'Geçersiz tarih formatı',
  'label.no_privacy_policy': "''Bitti'' butonuna tıklayarak ilerleyebilirsiniz.",
  'label.status': 'Durum',
  'moduleTitle.attached_with_observation': 'gözlem ile eklenmiştir',
  'moduleTitle.revise_message_rp': 'Toplumsal Uyum Projeniz Ödül Lideriniz tarafından gözden geçirildi.',
  'file.activity_section_summary': '{section}-bölümü-özeti',
  'label.download_section_summary': 'Bölüm özetini indirin',
  'label.award_summary': 'Ödül Özeti',
  'btn.download_summary_for_assessor': 'Assessor için özet rapor indir',
  'label.first_activity_started': 'İlk aktiviteye başlandı',
  'label.hours_completed_required': 'Tamamlanan/Gerekli Saatler',
  'label.weeks_completed_required': 'Tamamlanan/Gerekli Haftalar',
  back_to_home: 'Anasayfaya dön',
  'label.activity_rejected_click': 'Aktiviteniz Ödül Lideriniz tarafından reddedildi. Tıklayınız:',
  'button.more_information': 'Daha Fazla Bilgi',
  'label.attached_file': 'Dosya ekle',
  'moduleTitle.journey_details': 'Macera ve Keşif Yolculuğu Detayları',
  'tabs.activity': 'Aktivite',
  'label.confirm_email': 'E-postayı onayla',
  'label.aj_rejected_click': 'Macera ve Keşif Yolculuğu, Ödül Lideriniz tarafından reddedildi. Tıklayınız:',
  'label.verifying_payment': 'Ödemeyi Onayla',
  'button.finish_and_pay': 'Bitir ve Öde',
  'label.payment_not_successful_text': 'Ödülünüz için ödemeyi başarılı şekilde tamamlayamadınız, şimdi ödeme yapmanız gerekmektedir.',
  'label.payment_not_completed': 'Ödeme yapılamadı',
  'button.pay_now': 'Şimdi Öde',
  'label.registration_pending_parental_consent': 'Kaydınızın tamamlanması için Ebeveyn onayını bölümünün tamamlanması gerekmektedir',
  'button.edit_observation': 'Gözlem Ekle',
  'moduleTitle.qualifying': 'Asıl Kamp',
  'moduleTitle.practice': 'Hazırlık Kampı',
  'label.first_log_entry': 'İlk aktivite kaydı girişi',
  'label.first_log_entry_date': 'İlk aktivite kaydı girişi tarihi',
  'label.last_log_entry': 'Son aktivite kaydı girişi',
  'label.last_log_entry_date': 'Son aktivite kaydı giriş tarihi',
  'label.you_can_send_journey_report_for_approval': '{journey} Yolculuğu raporunuzu onaya gönderiniz.',
  'button.edit_and_resend_report': 'Raporu düzenle ve tekrar gönder',
  'label.your_journey_is_complete': '{journeyType} Yolculuğunuz tamamlanmıştır.',
  'button.add_additional_journey': 'İlave macera ve keşif yolculuğu ekle',
  'moduleTitle.edit_journey': 'Macera ve Keşif Yolculuğunuzu düzenleyin',
  'notifications.assessment_sent': 'Değerlendirme gönderildi',
  'notifications.file_is_too_big': 'Dosya yüklenemiyor. Dosyanız çok büyük olabilir.',
  'notifications.authorization_code_has_expired': 'Yetki kodunun süresi dolmuştur',
  'route.confirm_email': 'E-postayı onayla',
  'label.assessor_needs_account': 'Online Record Book (ORB) sisteminde işlem yapmak için kişisel ORB hesabına sahip olmalısınız. <br/> Lütfen buraya bilgilerinizi girerek başlayınız',
  'label.company_name': 'Şirket ismi',
  'label.secondary_email_again': 'İkinci e-posta adresini onayla',
  'label.how_many_years': 'Kaç yıl/ay?',
  'label.no_company_leave_empty': 'Bir şirkette çalışmıyorsanız bu bölümü boş bırakınız.',
  'label.secondary_phone_number': 'İkinci telefon numarası',
  'label.secondary_phone_type': 'İkinci telefon numarası türü',
  'label.wwc_application_number': 'Çocuk Koruma Numarası',
  'label.wwc_expiration_date': 'Çocuk Koruması Bitiş Tarihi',
  'label.you_are_now_registering_as_assessor': 'Şuan assessor olmak için kayıt oluyorsunuz',
  'label.you_have_finished_aj_now_send_to_approval': "Macera ve Keşif Yolculuğu tamamlandı. Macera ve Keşif Yolculuğunuzu, onay için Assessor'a kendi yorumunuzu ekleyerek gönderebilirsiniz.",
  'label.your_experience': 'Deneyiminiz',
  'label.your_qualification': 'Yetkinlikleriniz',
  'notifications.waiting_for_assessor_approval': 'Assessor onayı bekleniyor',
  'button.resend_assessment_request': 'Değerlendirme İsteğini Tekrar Gönder',
  'errors.emails_must_be_different': 'İkincil e-posta adresiniz birincil e-posta adersinizden farklı olmalıdır.',
  'moduleTitle.company_details': 'Şirket Bilgileri',
  'notifications.already_resent_assessment_request': 'Değerlendirme istediği daha önce gönderdiniz',
  'route.assessor_dashboard': 'Assessor Anasayfası',
  'pageTitle.register_assessor': 'Assessor Kaydı',
  'wizard.assessor_details': 'Assessor Bilgileri',
  'wizard.assessor_experience': 'Assessor Deneyimi',
  'wizard.personal_details': 'Kişisel Bilgiler',
  'button.sign_off': 'Bitirme Onayı',
  'button.sign_off_dashed': 'Bitirme Onayı',
  'moduleTitle.sign_off': 'Ödül Bitirme Onayı',
  'label.certify_participant_met_reqs': 'Assessor olarak katılımcının bu aktivite için tüm gerekliliktleri yerine getirdiğini onaylıyorum.',
  'label.assessor_report': 'Assessor raporu',
  'label.content_update': 'Lütfen bekleyiniz. Güncelleniyor...',
  'label.comment_on_participant_improvement': 'Lütfen katılımcının performansı/gelişimi için yorum yapınız',
  'note.edit_participant_review': 'Bu bilgileri düzenlemek için lütfen Düzenle butonunu tıklayınız.',
  'errors.min_age': 'Minimum yaş {age}',
  'notifications.assessor_link_expired': 'Assessor kayıt linkinin süresi dolmuştur.',
  'label.secondary_email': 'İkinci e-posta',
  'moduleTitle.review_participant_info': 'Katılımcı Bilgilerini Düzenle',
  'label.loading_payment_gateway': 'Ödeme Noktasını Yüklüyor',
  'label.consent_given_login_as_child': 'İzin verilmiştir. Lütfen çocuğunuz olarak giriş yapınız.',
  'notifications.only_one_qualification_journey_per_award': 'Bir Ödül için sadece bir adet Asıl Yolculuk düzenlenebilir',
  'label.registration_fees_participant': 'Kayıt Bağış Ödemesi - {name} (#{id})',
  'moduleTitle.leader_details': 'Ödül Lideri Bilgileri',
  'label.leader_name': 'Ödül Lideri Adı',
  'label.leader_phone': 'Ödül Lideri Telefon Numarası',
  'label.leader_email': 'Ödül Lideri E-posta Adresi',
  'moduleTitle.au_details': 'Ödül Birimi Bilgileri',
  'label.au_name': 'Ödül Birimi Adı',
  'label.assessor_guidelines': 'Yönergeler',
  'label.assessor_cond_req': 'Temel Koşul ve Gereklilikler',
  'label.assessor_ref_handbook': 'El Kitabına Referans',
  'label.assessor_ref_online_modules': 'Online Modüllere Referans',
  'label.participant_has_no_aj_report': 'Katılımcı henüz rapor yüklemedi.',
  'moduleTitle.participant_details': 'Katılımcı Bilgileri',
  'label.participants_has_no_logs': 'Katılımcı henüz bir aktivite kaydır girişi yapmadı.',
  'label.location_type': 'Lokasyon Türü',
  'label.activity_ready_for_signoff': 'Aktivite bitirme onayı için hazır.',
  'label.activities': 'Aktiviteler',
  'label.choose_how_you_want_to_login': 'Nasıl giriş yapmak istediğinizi seçiniz:',
  'roles.leader': 'Ödül Lideri',
  'roles.award_verifier': 'Ödül Onaylayan Kişi',
  'roles.coordinator': 'Koordinatör',
  'roles.aj_assessor': 'Macera ve Keşif Yolculuğu Assessor',
  'roles.aj_supervisor': 'Macera ve Keşif Yolculuğu Supervisorı',
  'roles.instructor': 'Eğitici',
  'roles.nao_staff': 'Ulusal Ofis Personeli',
  'roles.super_user': 'Super-user',
  'roles.user': 'Kullanıcı',
  'roles.viewer': 'Görüntülen Kişi',
  'roles.authorizing_contact': 'Yetkili Kişi',
  'roles.if_staff_superuser': 'Uluslararası Ödül Vakfı Superuser',
  'roles.if_staff_statistical_user': 'Uluslararası Ödül Vakfı İstatistik Kullanıcısı',
  'roles.if_staff_viewer': 'Uluslararası Ödül Vakfı Görüntüleyici Kullanıcı',
  'roles.aj_instructor': 'Macera ve Keşif Eğitmeni',
  'label.if_you_have_questions_au': 'Kaydınız ile ilgili sorularınız varsa lütfen Ödül Biriminiz ile iletişime geçiniz.',
  'label.we_will_send_you_an_email_leader': 'ORB sistemindeki kaydınız onaylandığında sizi e-posta yolu ile bilgilendireceğiz.',
  'moduleTitle.rejecting_assessor_invitation': 'Assessor olmak için gönderilen davet reddeddildi.',
  'notifications.assessor_invitation_rejected': 'Assessor olma daveti reddedildi',
  'moduleTitle.participants_list_is_empty': 'Katılımcı listesi boş',
  'label.note_from_participant': 'Katılımcıdan not',
  'label.you_can_send_aj_to_leader': 'Macera ve Keşif Yolculuğunuzu, Ödül Liderinizin onayına gösterebilirsiniz. ',
  'button.save_report': 'Raporu kaydet',
  'label.this_activity_has_no_assessor': 'Bu aktivite için bir danışman/assessor yok. Aktiviteyi onaya göndermeden önce bir danışman atamalısınız.',
  'label.activity_rejected_click_by_assessor': 'Aktiviteniz Assessor tarafından reddedildi. Tıklayınız:',
  'button.reject': 'Reddet',
  'button.reject_invitation': 'Daveti reddet',
  'label.reason': 'Sebep',
  'label.accept_invitation_and_continue': 'Daveti kabul et ve devam et ',
  'pageTitle.registration_reject': 'Kaydı Reddet',
  'errors.you_must_be_older_than_register_for_leader': 'Ödül Lideri olmak için {years} yaşından ve {months} aydan büyük olmalısınız.',
  'label.your_report_approve_now_send_to_leader_without_note': 'Raporunuz onaylandı! Şimdi, Ödül Liderinizin onayına gönderebilirsiniz.',
  'button.stop_assessing_this_activity': 'BU AKTİVİTEYİ DEĞERLENDİRMEYİ DURDUR',
  'button.confirm': 'Onayla',
  'moduleTitle.are_you_sure': 'Emin misiniz?',
  'label.content_restore': 'İçeriği ',
  'button.stop_editing': 'Düzenlemeyi durdur',
  'notifications.activity_has_been_rejected': 'Aktivite reddedildi',
  'notifications.aj_has_been_rejected': 'Macera ve Keşif Yolculuğu reddedildi',
  'notifications.rp_has_been_rejected': 'Toplumsal Uyum reddedildi',
  'moduleTitle.additional_files': 'Ek belgeler',
  'moduleTitle.no_additional_files': 'Ek belgeler',
  'moduleTitle.stop_assessing_section': 'Bölümü değerlendirmeyi durdur',
  'label.show_security_and_refund_policy': 'Güvenliği ve geri ödeme politikasını gösteriniz',
  'moduleTitle.security_and_refund_policy': 'Güvenlik ve geri ödeme politikası',
  'label.fees_payment': 'Harç/Ücret ödeneği',
  'label.redund_policy': 'Geri ödeme politikası',
  'label.security_policy': 'Güvenlik politikası',
  'label.leave_blank': 'Boş bırak',
  'label.frequently_asked_questions': 'Sıkça Sorulan Sorular',
  'label.language_selection_is_disabled_for_iac': 'Dil seçimi Bağımsız Ödül Birimleri için etkin değildir',
  'errors.min_nights_required': 'En az {nights} gece sayısı gereklidir',
  'label.completion_date': 'Tamamlama Tarihi',
  'label.you_are_offline': 'Çevrimdışısınız. Yapılan değişiklikler kaydedilemeyebilir.',
  'errors.start_date_after_award_start': "Başlama tarihi güncel Ödül'ün başlama tarihinden önce olamaz.",
  'label.participants': 'Katılımcılar',
  'label.marketing_from_iaf': "Uluslararası Dernek'ten pazarlama materyali alma seçeneği",
  'label.marketing_from_oa': 'Uygulayıcı yetkiliden pazarlama materyalleri alma seçeneği',
  'label.marketing_from_nao': "NAO'dan pazarlama materyalleri alma seçeneği",
  'label.select_iac': "Bağımsız Ödül Merkezi'ni seçiniz",
  'label.you_will_be_redirected_to_the_paypal_payment': 'Lütfen yukarıdaki online Öde butonuna tıklayınız ve Visa, MasterCard, kredi kartı veya PayPal hesabınızı kullanarak ödemeyi gerçekleştiriniz',
  'notifications.report_has_been_sent': 'Rapor gönderildi',
  'label.processing_paypal_payment': 'PayPal ödemesi işlem hâlinde',
  'label.loading_paypal_gateway': 'PayPal ödeme noktasını yüklüyor',
  'label.payment_failed': 'Ödeme başarısız',
  'label.payment_has_been_cancelled': 'Ödeme iptal edildi ya da başarısız oldu',
  'roles.naa_oa_staff': 'NAO Personeli',
  'label.download_report_and_upload_signed_version': 'Raporu indirin ve imzalı versiyonunu yükleyiniz',
  'button.download_summary_for_assessor': 'Danışman için özeti indirin',
  'label.pay_online_mastercard': 'Online Ödeme',
  'label.pay_online_paypal': 'Online Ödeme',
  'notifications.authorization_code_is_missing': 'Yetkilendirme kodu bulunamamaktadır',
  'errors.unknown_payment_error': 'Ödeme sırasında bilinmeyen bir hata oldu',
  'errors.already_in_use_by_auth_contact': 'Bu e-posta Yetkili Birim tarafından kullanılmaktadır',
  'roles.if_staff_stat_user': 'Eğer istatiksel kullanıcıysanız',
  'moduleTitle.you_have_been_logged_out_due_to_inactivity': '',
  'announcement.survey_description.do_think_people_are_lazy': '',
  'announcement.survey_title.join_our_global_survey': '',
  'announcement.survey_button.if_below_25': '',
  'announcement.survey_button.if_over_25': '',
  'moduleTitle.privacy_and_cookie_policy': '',
  'label.we_have_made_some_important_changes': '',
  'button.i_agree': '',
  'button.see_more_details': '',
  'label.the_cookie_settings_on_this': ''
}
